import React, { useState } from 'react';
import { Icon } from 'react-icons-kit';
import Fade from 'react-reveal/Fade';
import { arrowRight } from 'react-icons-kit/feather/arrowRight';
import Heading from 'common/components/Heading';
import NextImage from 'common/components/NextImage';
import Text from 'common/components/Text';
import PropTypes from 'prop-types';
import Link from 'next/link';
import {
  ContainerBlog,
  FilterBlogContainer,
  ListBlogContainer,
} from 'containers/SaasModern/Blog/blog.style';
import { Title, BoxStyled, BoxDescription } from './style';
import { format } from 'date-fns';
import { Section, Grid, Article } from '../LatestBlog/LatestBlog.style';
import { BannerWrapperNav } from 'containers/SaasModern/Banner/banner.style';
import { PrismicRichText } from 'common/components/PrismicRichText/PrismicRichText';
import Container from 'common/components/UI/Container';
import FilterBlogs from '../FilterBlogs';
import { useRouter } from 'next/router';
import Box from 'common/components/Box';

const AllBlogs = ({ imageStyle, data, data_main, articleTags }) => {
  const router = useRouter();
  const { articleTag, title } = router.query;
  return (
    <>
      <BannerWrapperNav />
      <BoxStyled>
        <Title>{data_main.data.title}</Title>
        <BoxDescription>
          <PrismicRichText field={data_main.data.description} />
        </BoxDescription>
      </BoxStyled>
      <Section id="newsfeed">
        <Container width="1400px">
          <ContainerBlog>
            <FilterBlogContainer>
              <FilterBlogs
                labelCategory={data_main.data.category}
                labelResetFilter={data_main.data.reset_filter}
                placeholderInput={data_main.data.placeholder_input}
                listTags={articleTags}
                filter={title}
              />
            </FilterBlogContainer>
            <ListBlogContainer>
              <Grid>
                {data
                  .filter((article) => {
                    const findByText = title
                      ? article.data.title
                          .toLowerCase()
                          .includes(title.toLowerCase())
                      : true;

                    const filterByTags = articleTag
                      ? article.data.article_tags.find((tag) => {
                          return tag.article_tag.slug
                            ? tag.article_tag.slug
                                .replace(/-/g, ' ')
                                .toLowerCase() ===
                                articleTag.replace(/-/g, ' ').toLowerCase()
                            : false;
                        })
                      : true;

                    return filterByTags && findByText;
                  })
                  .map((article) => {
                    const published_date = new Date(
                      article.data.published_date,
                    );
                    const formatedDate = format(published_date, 'MMM dd, yyyy');
                    return (
                      <Link
                        href={`/blog/${article.uid}`}
                        style={{ textDecoration: 'none' }}
                        locale={router.locale}
                      >
                        <Fade key={article.id} up delay={article.id * 100}>
                          <Article>
                            <NextImage
                              style={imageStyle}
                              field={article.data.hero_image}
                            />
                            <Text
                              style={{ color: '#000' }}
                              content={formatedDate}
                            />
                            <Heading
                              as="h4"
                              style={{ color: '#000' }}
                              content={article.data.title}
                            />
                            <Box>
                              {'Learn more'} <Icon icon={arrowRight} />
                            </Box>
                          </Article>
                        </Fade>
                      </Link>
                    );
                  })}
              </Grid>
            </ListBlogContainer>
          </ContainerBlog>
        </Container>
      </Section>
    </>
  );
};
AllBlogs.propTypes = {
  imageStyle: PropTypes.object,
};
AllBlogs.defaultProps = {
  imageStyle: {
    width: 300,
    height: 200,
    borderRadius: '10px',
  },
};

export default AllBlogs;
